export async function useYscFetch<T = any>(url: string, options?: Parameters<typeof $fetch>['1']) {
  const { public: { api: { blog: { url: blogApiUrl } } } } = useRuntimeConfig()
  return await $fetch<T>(`${blogApiUrl}${url}`, options)
}
